<template>
    <v-container fluid>
        <v-row>
            <!-- Sidebar -->
            <v-col cols="3">
                <v-card class="pa-4">
                    <v-card-title>Options</v-card-title>
                    <v-divider></v-divider>
                    <v-select v-model="selectedOption" label="Select option" dense outlined :items="options"></v-select>
                    <v-text-field label="Input 1" dense outlined></v-text-field>
                    <v-text-field label="Input 2" dense outlined></v-text-field>
                    <v-btn block color="primary">Load Section</v-btn>
                </v-card>
            </v-col>
            <v-col cols="9">
                <v-text-field
                        v-model="xmlIdsInput"
                        label="XML ID(s)"
                        outlined
                        dense
                ></v-text-field>

                <v-btn color="primary" @click="loadSection" :loading="isLoading">
                    Load Section
                </v-btn>

                <default-content-section-controller
                        :xmlIdsQuery="xmlIds"
                        @loading="setLoading"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import DefaultContentSectionController from "../../components/content-section/DefaultContentSectionController.vue";

export default {
    components: { DefaultContentSectionController },
    data() {
        return {
            xmlIdsInput: '', // bound to input field
            xmlIds: '',     // passed to child only on button click
            isLoading: false,
            options: ['General'],
            selectedOption: 'General'
        };
    },
    methods: {
        loadSection() {
            this.xmlIds = this.xmlIdsInput;
        },
        setLoading(value) {
            this.isLoading = value;
        },
    },
};
</script>
